module.exports = __webpack_public_path__ + "media/images/common/box_bg-7682adb480f4050407bdb18c75df980d.gif";